import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["canvas", "input"]
  start(event) {
    // Touches use non-passive touch handlers so Safari cannot take over a stroke.
    if (event.pointerType === "touch" || this.drawing || event.button !== 0) return
    event.preventDefault()
    this.pointerId = event.pointerId
    this.begin(event)
    try {
      this.canvasTarget.setPointerCapture(event.pointerId)
    } catch {
      // A capture failure must not prevent the canvas from drawing.
    }
  }
  touchStart(event) {
    event.preventDefault()
    if (this.drawing) return
    const touch = event.changedTouches[0]
    this.touchId = touch.identifier
    this.begin(touch)
  }
  touchMove(event) {
    event.preventDefault()
    const touch = Array.from(event.changedTouches).find(touch => touch.identifier === this.touchId)
    if (touch) this.stroke(touch)
  }
  touchFinish(event) {
    event.preventDefault()
    const touch = Array.from(event.changedTouches).find(touch => touch.identifier === this.touchId)
    if (!touch) return
    this.stroke(touch)
    this.save()
    this.touchId = null
  }
  begin(event) {
    this.drawing = true
    const ctx = this.canvasTarget.getContext("2d")
    ctx.lineWidth = 2
    ctx.lineCap = "round"
    ctx.lineJoin = "round"
    ctx.beginPath()
    const [x, y] = this.point(event)
    ctx.moveTo(x, y)
    ctx.lineTo(x + 0.1, y + 0.1)
    ctx.stroke()
  }
  draw(event) {
    if (event.pointerId !== this.pointerId) return
    this.stroke(event)
  }
  stroke(event) {
    if (!this.drawing) return
    const ctx = this.canvasTarget.getContext("2d")
    ctx.lineTo(...this.point(event))
    ctx.stroke()
  }
  finish(event) {
    if (event.pointerId !== this.pointerId) return
    this.save()
    this.pointerId = null
  }
  save() {
    if (!this.drawing) return
    this.drawing = false
    this.inputTarget.value = this.canvasTarget.toDataURL("image/png")
  }
  clear() {
    this.drawing = false
    this.pointerId = null
    this.touchId = null
    this.canvasTarget.getContext("2d").clearRect(0, 0, this.canvasTarget.width, this.canvasTarget.height)
    this.inputTarget.value = ""
  }
  point(event) {
    const rect = this.canvasTarget.getBoundingClientRect()
    return [(event.clientX - rect.left) * this.canvasTarget.width / rect.width, (event.clientY - rect.top) * this.canvasTarget.height / rect.height]
  }
}
